import { React, useEffect, useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useGetEpbDownloadUnitOfficeWiseEciReportMutation, useGetForceWingDataQuery,useGetStatesStatusForceWiseQuery } from "../../../services/reportsServices";
import { Validators } from "../../../library/utilities/Validator";
import { downloadExcelFile, downloadPdfFile, parseJwt } from "../../utilities/utils"
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import MultiSelectCheckBox from "../../../ui/multiSelectCheckbox/MultiSelectCheckBox";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "Phase No",
  "Force /Wing Name",
  "Unit Office ID",
  "Total e-PB generated",
  "Total e-PB downloaded",
  "Total e-PB pending for downloaded",
];

const phaseList = [
];

const EpbDownloadingUnitOfficeWiseEciReport = () => {  
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "e-Postal Ballot Downloading Report Unit Office Wise"
  const SheetName = "Unit Office Wise Report "
  const [states, setStates] = useState({
    stateValue: "",
    forceId: "",
  });

  const [ Error,setError] = useState({});
  // const stateList = [{ value: "", label: " Select State" }];
  const forceWingList = [{ value: "", label: " Select Force/Wing" }];
  const [tableData,setTableData] = useState([]);
  const [selected, setSelected] = useState([]);
  // const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery();
  const { data: getForceWingData ,isSuccess } = useGetForceWingDataQuery();
  const [getReports] = useGetEpbDownloadUnitOfficeWiseEciReportMutation()
  const tableHeader = [];
  const columns = [
    {
      Header: "Phase No",
      accessor: "col1",
    },
    {
      Header: "Force/Wing Name",
      accessor: "col2",
    },
    {
      Header: "Unit Office ID",
      accessor: "col3",
    },
    {
      Header: "Total e-PB Generated",
      accessor: "col4",
    },
    {
      Header: "Total e-PB Downloaded",
      accessor: "col5",
    },
    {
      Header: "Total e-PB Pending for Download",
      accessor: "col6",
    },
  ];
  columns.map((item)=>{
    tableHeader.push(item.Header)
  })

  useEffect(()=>{
    const Phases = JSON.parse(localStorage?.phaseList)
    Phases.map((item)=>{
     phaseList.push({value:item, label:item})
    })
 
   },[])
   
  // getElectionAnnouncedState?.payload?.map((item) => {
  //   stateList?.push({
  //     value: item.stateCd,
  //     label: item.stateName,
  //   });
  // });
  getForceWingData?.payload?.map((item) => {
    forceWingList?.push({
      value: item.forceAbbre,
      label: item.forceName,
    });
  });

  const handleChange = (key, value) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const renderTableData = () => {
    let error = {};
    if (!selected || selected.length === 0) {
      error["phaseList"] = "This field is required";
    }
    if (!states.forceId || states.forceId === "" || states.forceId.length == 0) {
      error["forceId"] = "This Field is required"
    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }

    const data = [];
    selected.map((item) => data.push(item.value));

    let payload = {
      "stateCd": data,
      "forceWing": states.forceId
    }
      getReports(payload)
        .unwrap()
        .then((res) => {
          let tData = []
          res?.payload?.map((item) => {
            tData.push({
              "col1": item.phaseNo,
              "col2": item.forceName,
              "col3": item.unitOfficeId,
              "col4": item.totalEpbGenerated,
              "col5": item.totalEpbDownloaded,
              "col6": item.epbPendingForDownload,
            });
          });
          setTableData(tData)
         setTotalNoOfRecords (res?.payload?.length)
        }).catch((error) => {
          if(error?.data?.message==="No record found")
          {
            
            setTableData([])
          }
        })
  };

  
  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  useEffect(()=>{
    if((localStorage.userrole==="nodal") && isSuccess ){
      setStates((prevState)=>({
        ...prevState,
        forceId:parseJwt(localStorage?.access_token)?.FORCE_ID
      }))
    }
  },[isSuccess])

  return (
    <LeftMenu>
    <div className="container box shadow ">
      <div className="row">
          <div className="col-md-12">
          <RunnerUpHeaderNew title={reportName}
           onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData, false, true)}
          onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData)}/>
          </div>
      </div>
      <div className="row">
        <div className="col-md-2" style={{paddingRight:"0px"}}><p style={{textAlign:"right",paddingTop:"6px"}}>Select Phase</p></div>
          <div className="col-md-4">
            <MultiSelectCheckBox
              options={phaseList}
              name="phaseList"
              value={selected}
              className={"col-md-12"}
              onChange={setSelected}
              labelledBy="Select"
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("phaseList", val)}
              Error={Error}
            ></MultiSelectCheckBox>
          </div>
          <SelectField
            labelClass=""
            inputClass="col-md-2 pr-1"
            name="forceId"
            disabled={localStorage.userrole==="nodal"}
            value={states.forceId}
            handleChange={(val) => handleChange("forceId", val)}
            options={forceWingList}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              }
            ]}
            getError={(val) => getError("forceId", val)}
            Error={Error}
          />
        <div className="col-md-2 download_button">
        <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={renderTableData}>
              VIEW
              <span className="pl-2">
                <i class="fa fa-eye">
                </i>
              </span>
            </button>
        </div>
      </div>
      <div style={{marginTop:"0px"}}>
        <Table
              placeholder="Search"
              globalsearch={true}
              selectall={true}
              emptyMessage="No Record Found"
              columns={columns}
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              tableClassNameCheck="contenttable-eroll"
              pagination
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
        </div>
    </div>
  </LeftMenu>
  );
};
export default EpbDownloadingUnitOfficeWiseEciReport;
